﻿import { Item, ItemChagemBool } from '@app/api/minuta/ItemClausula';
import { getAllPerguntaComResposta, Pergunta } from '@app/api/minuta/Pergunta';
import { Resposta } from '@app/api/minuta/Resposta';
import { Button, FormatText, FormInput, FormSubmitButton, Icon, MasterDetailForm, Row, Widget } from '@digital/ui';
import { Collapse, Modal, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import TabelaRespostasItemClausula from './TabelaRespostasItemClausula';

interface ModalSelectRespostaTabelaProps {
  item: Item;
  handUpdateSempreVisivel: (values: ItemChagemBool, clausulaId: string) => void;
  ehColunaResposta: boolean;
  disabled?: boolean;
  onGetRespostasSelecionadas: (respostas: Resposta[]) => void;
}

const ModalSelectRespostaTabela = ({
  item,
  handUpdateSempreVisivel,
  ehColunaResposta,
  disabled = false,
  onGetRespostasSelecionadas,
}: ModalSelectRespostaTabelaProps) => {
  const { Panel } = Collapse;
  const [perguntaResult, setPerguntaResult] = useState<Pergunta[]>([]);
  const [exibirModal, setExibirModal] = useState(false);
  const [respostas, setRespostas] = useState<Resposta[]>([]);

  useEffect(() => {
    setRespostas([]);
    setPerguntaResult({} as Pergunta[]);

    if (exibirModal) {
      if (item.respostas) {
        setRespostas(item.respostas);
      }
      getAllPerguntaComResposta().then(data => {
        if (data) {
          setPerguntaResult(data);
        }
      });
    }
  }, [exibirModal]);

  const undoFiltering = () => {
    getAllPerguntaComResposta().then(data => {
      if (data) {
        setPerguntaResult(data);
      }
    });
  };

  const handleSearchTerm = (values: any) => {
    if (values.termo == '') {
      undoFiltering();
    } else {
      const filteredPerguntaResult = perguntaResult.filter(per =>
        per.pergunta.toUpperCase().includes(values.termo.toUpperCase()),
      );
      setPerguntaResult(filteredPerguntaResult);
    }
  };

  const onCloseModal = () => {
    setRespostas([]);
    undoFiltering();
    setExibirModal(false);
  };

  const onSelectResposta = () => {
    onGetRespostasSelecionadas(respostas);
    onCloseModal();
  };

  return (
    <>
      {ehColunaResposta ? (
        <div
          onClick={() => {
            onCloseModal();
            setExibirModal(true);
          }}>
          {item.respostas &&
            item.respostas.length > 0 &&
            !item.visivel &&
            item.respostas.map(r => r.descricao).join(', ')}
        </div>
      ) : (
        <Switch
          defaultChecked={item.visivel}
          checked={item.visivel}
          onChange={() => {
            const itemChange = {
              id: item.id,
              valor: !item.visivel,
            } as ItemChagemBool;
            if (itemChange.valor === false) {
              onCloseModal();
              setExibirModal(true);
            } else {
              handUpdateSempreVisivel(itemChange, item.clausulaId);
            }
          }}
          key="sempreVisivel"
        />
      )}

      {exibirModal && !disabled && (
        <Modal
          title="Pesquisa de resposta"
          width="800px"
          visible={exibirModal}
          onCancel={onCloseModal}
          footer={[
            <Button key="submitCancelar" type="link" onClick={onCloseModal}>
              Fechar
            </Button>,
            respostas.length > 0 && (
              <Button key="submitEnviar" type="primary" onClick={onSelectResposta}>
                Enviar
              </Button>
            ),
          ]}>
          <MasterDetailForm
            initialValues={{}}
            key="formTemplate"
            onSubmit={handleSearchTerm}
            actions={[
              <Button key="close" type="link" onClick={onCloseModal}>
                Fechar
              </Button>,
              <FormSubmitButton key="search" noIcon type="primary">
                <FormatText id="ui.commons.search" uppercase />
              </FormSubmitButton>,
            ]}>
            <Widget>
              <Row style={{ margin: '0px' }}>
                <FormInput name="termo" label="Termo" defaultValue={''} id={'perguntaFilter'} />
              </Row>
            </Widget>
          </MasterDetailForm>

          <>
            {perguntaResult && perguntaResult.length > 0 ? (
              <>
                {perguntaResult.map(pergunta => {
                  return (
                    <Collapse key={`${pergunta.id}`} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                      <Panel key={`${pergunta.id}`} header={`${pergunta.pergunta}`}>
                        <Widget>
                          <TabelaRespostasItemClausula
                            perguntaResult={pergunta}
                            onSelectResult={res => setRespostas(res)}
                            respostasChecked={respostas}
                            ocultaEdicao
                          />
                        </Widget>
                      </Panel>
                    </Collapse>
                  );
                })}
              </>
            ) : (
              <></>
            )}
          </>
        </Modal>
      )}
    </>
  );
};

export default ModalSelectRespostaTabela;
